import React from "react";
import axios from "axios";
import { t } from "../../localization/localization";

import { Row, Container, Col } from "react-bootstrap";
import { Bar } from "react-chartjs-2";

export default class MakaleSayisi extends React.Component {
  state = {
    data: [],
  };

  componentDidMount() {
    axios
      .get(`${window._env_.BASE_URL}/gcris-api/report/makaleSayisi`)
      .then((res) => {
        this.setState({
          data: res.data
            .sort((e1, e2) => e1.year - e2.year)
            .map((e) => {
              return { label: e.year, data: e.count };
            }),
        });
      });
  }

  render() {
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const locale = urlSearchParams.get("locale") ?? "tr";
    return (
      <Container>
        <Row>
          <h4>{t(locale, "/home/makaleSayisi/title")}</h4>
        </Row>
        <Row>
          <Bar
            data={{
              labels: this.state.data.map((e) => e.label),
              datasets: [
                {
                  label: t(locale, "/home/makaleSayisi/title"),
                  fill: true,
                  backgroundColor: "rgba(0, 31, 84, 1)",
                  data: this.state.data.map((e) => e.data),
                },
              ],
            }}
            width={440}
            height={290}
            options={{
              title: t(locale, "/home/makaleSayisi/title"),
              maintainAspectRatio: false,
              plugins: {
                datalabels: {
                  display: false,
                },
              },
            }}
          />
        </Row>
      </Container>
    );
  }
}
